/*
Runs on every page.
*/
import {AccessibleDropdown} from '../../lib/components/AccessibleDropdown';
import {MobileMenu} from '../../lib/components/MobileMenu';
import {MediaGallery} from '../../lib/components/MediaGallery';
import {ButtonGroup} from '../../lib/components/ButtonGroup';
import {ContentSwitcher} from '../../lib/components/ContentSwitcher';
import {Slider}  from '../../lib/components/Slider';
import {eventEmitter} from '../../lib/components/EventEmitter';
import {getBreakpointSize} from '../../lib/js/tools';
import {Accordion}  from '../../lib/components/Accordion';
import * as PageScrollWatcher from '../../lib/components/PageScrollWatcher';
import * as Router from '../../lib/components/Router';
import * as AdminPage from './pages/admin';
import * as HomePage from './pages/home';
import * as DemoPage from './pages/demo';


function disableClickFocus() {
  /*
  Because focus outlines don't look good for clicks.
  */
  const elements = document.querySelectorAll('a, button, [tabindex]');
  for (const element of elements) {
    element?.addEventListener('mousedown', (event) => {
      event.preventDefault();
    });
  }
}

function createMobileMenu() {
  const element = document.querySelector('.jk-mobile-menu');
  const menu = new MobileMenu({
    element,
    onToggle({isOpen}) {
      // must scroll to top of page for tablet devices to align with header
      if (isOpen && getBreakpointSize() === 'M') {
        document.documentElement.scrollTop = 0;
      }
    },
  });
  window.mobileMenu = menu;
  console.log(menu);
}

function createAccessibilityDropdowns() {
  const elements = document.querySelectorAll('nav .has-children');
  for (const element of elements) {
    const dropdown = new AccessibleDropdown(element);
    console.log(dropdown);
  }
}

function createMediaGalleries() {
  const elements = document.querySelectorAll('.jk-media-gallery');
  for (const element of elements) {
    const gallery = new MediaGallery(element);
    console.log(gallery);
  }
}

function createButtonGroups() {
  const elements = document.querySelectorAll('.jk-button-group');
  for (const element of elements) {
    const buttonGroup = new ButtonGroup({
      element,
      onSelect(buttonId) {
        eventEmitter.emit('button-group:select', {buttonId: buttonId});
      }
    });
    console.log(buttonGroup);
  }
}

function createContentSwitchers() {
  const contentSwitchers = [];
  const elements = document.querySelectorAll('.jk-content-switcher');
  for (const element of elements) {
    const contentSwitcher = new ContentSwitcher(element);
    contentSwitchers.push(contentSwitcher);
  }
  console.log(contentSwitchers);

  eventEmitter.on('button-group:select', ({message}) => {
    const contentId = message?.buttonId;
    for (const contentSwitcher of contentSwitchers) {
      contentSwitcher.show(contentId);
    }
  });
}

function createAccordions() {
  const components = [];
  const elements = document.querySelectorAll('.jk-accordion');
  for (const element of elements) {
    const component = new Accordion(element);
    components.push(component);
  }
  console.log(components);
}

function createSliders() {
  const components = [];
  const elements = document.querySelectorAll('.jk-slider');
  for (const element of elements) {
    const component = new Slider(element);
    components.push(component);
  }
  console.log(components);
}

function runRouter() {
  const routes = {
    '^/wp-admin/': AdminPage,
    '^/$': HomePage,
    '^/demo': DemoPage,
  };

  Router.run(routes);
}

function runScrollWatcher() {
  const config = {
    points: [
      {
        position: 10,
        className: 'scroll-event-10',
      }
    ],
  };
  PageScrollWatcher.run(config);
}

function overrideNavHashLinkBehavior() {
  /*
  For hash links that jump to an element, use `scrollIntoView` instead for a smooth transition.
  */
  const header = document.querySelector('.c-header');
  header?.addEventListener('click', (event) => {
    if (event.target.tagName === 'A') {
      const href = event.target.href;
      const url = new URL(href);
      const hash = url.hash;
      const scrollTarget = document.querySelector(hash);

      if (scrollTarget) {
        scrollTarget.scrollIntoView({behavior: 'smooth'});
        event.preventDefault();
        history.pushState({}, null, url);
        console.log(111);
        window.mobileMenu.close();
      }
    }
  });
}

/*
Global components should be created first,
because later scripts depend on their existance (like disableClickFocus).
*/
createMobileMenu();
createAccessibilityDropdowns();
createMediaGalleries();
createButtonGroups();
createContentSwitchers();
createAccordions();
createSliders();

runRouter();
runScrollWatcher();
disableClickFocus();
overrideNavHashLinkBehavior();
